'use client';
import PriceDetailsModal from '@/components/global/PriceDetailsModal';
import { useModal } from '@/components/ModalContext';
import { useSiteSettings } from '@/contexts/SiteSettingsContext';

// BL-652: size and weight moved behind `typeClassName` so a caller can
// actually change them. They were baked into the base string, and `text-[15px]`
// is an arbitrary value that outranks a plain `text-sm` passed via `className`
// regardless of class order — so those overrides were silently dead.
//
// The default now reproduces the Figma "Pricing Details" link style (Sea,
// Work Sans 14/150%, 0.028px tracking, underlined from-font) so every call site
// matches without repeating the same override strings.
export default function PriceDetails({
  className = '',
  typeClassName = 'text-[14px] font-normal leading-[150%] tracking-[0.028px]',
}) {
  const { openModal } = useModal();
  const { settings } = useSiteSettings();

  return (
    <button
      onClick={() => openModal(<PriceDetailsModal priceDetails={settings?.priceDetails} />, 'max-w-6xl', 'bg-white')}
      className={`font-worksans text-sea block cursor-pointer capitalize underline decoration-solid decoration-auto underline-offset-auto [text-decoration-skip-ink:none] [text-underline-position:from-font] ${typeClassName} ${className}`}
    >
      Pricing Details
    </button>
  );
}
